import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { I18N } from "aurelia-i18n";
import { MeasurementSystems } from '../../../converters/measurement-systems';
import { PressureConverter } from "../../../converters/pressure-value";

@autoinject
export class MilesitePipePressureChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			//this.chartData.datasets[1].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp).format("lll"));
				this.chartData.datasets[0].data.push(this.convertPressure(item.data.pressure));
				//this.chartData.datasets[1].data.push(item.data.humidity);
			});
			this.chart.refreshChart();
		}
	}

	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			datasets: [
				{
					label: `Pressure (${this.getPressureUnits()})`, // TODO:  get the correct unit kPA or PSI
					backgroundColor: "rgba(0,0,255,0.2)",
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(220,220,220,1)",
					yAxisID: "Pressure",
					data: []
				}
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						},
					}
				],
				yAxes: [
					{
						id: "Pressure",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Pressure"
						},
						position: "left"
					}
				]
			}
		};
	}

	getMeasurementSystem() {
		let system = localStorage.getItem("measurement-system");
		if (!system) {
			system = MeasurementSystems.imperial;
		}
		return system;
	}

	getPressureUnits(): string {
		let system = this.getMeasurementSystem();
		switch (system) {
			case MeasurementSystems.imperial:
				return "psi";
			case MeasurementSystems.metric:
				return "kPa";
			default:
				return "psi";
		}
	}

	convertPressure(pressure: number) {
		let system = this.getMeasurementSystem();
		switch (system) {
			case MeasurementSystems.metric:
				return pressure;
			case MeasurementSystems.imperial:
				return this.round(PressureConverter.toImperial(pressure), 1);
			default:
				return this.round(PressureConverter.toImperial(pressure), 1);
		}
	}

	round(value: number, precision: number): number {
		const multiplier = Math.pow(10, precision || 0);
		return Math.round(value * multiplier) / multiplier;
	}
}
